import React from 'react';

export class LogoBlock extends React.Component {
  render() {
    return (
      <div className="logo-block">
        <div className="main-logo">
          <a href="/dashboard"></a>
        </div>
        <div className="menu-toggler">
          <span><i className="fas fa-outdent"></i></span>
        </div>
      </div>
    );
  }
}
